import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/email-otp")({
	component: EmailOtpPage,
	ssr: false,
});

function EmailOtpPage() {
	return <AuthPage view="EMAIL_OTP" />;
}
